export enum AssetType {
  images = 'images',
  icons = 'icons',
  translations = 'i18n',
  fonts = 'fonts',
  flags = 'flags'
}
